const handleScrollBehavior = () => {
    const searchCondition = document.querySelector('.c-others-search-condition');
    if (!searchCondition) return;

    const breakpoint = 640;
    let lastScrollTop = 0;

    // 初期位置を取得（ページロード時）
    const initialOffsetTop = searchCondition.offsetTop;
    const elementHeight = searchCondition.offsetHeight;
    const triggerPoint = initialOffsetTop + elementHeight; // fixed になる基準点

    window.addEventListener('scroll', () => {
        if (window.innerWidth > breakpoint) return;

        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        const isScrollingUp = currentScroll < lastScrollTop;

        // triggerPointを越えたらfixed付与
        if (currentScroll > triggerPoint) {
            searchCondition.classList.add('is-fixed');

            // スクロール方向で開閉
            if (isScrollingUp) {
                searchCondition.classList.add('is-scroll-up');
            } else {
                searchCondition.classList.remove('is-scroll-up');
            }
        } else {
            searchCondition.classList.remove('is-fixed', 'is-scroll-up');
        }

        lastScrollTop = currentScroll;
    });
};

const main = () => {
    if (document.querySelector('#page-estate-index') == null) return;

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const sort = e.currentTarget.value;
            console.log(sort);
            document.querySelector(`button[name="sort"][value="${sort}"]`).click();
        });
    });

    handleScrollBehavior();
};

export default main;
